import { Languages } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from '@/hooks/useTranslation'

interface LanguageConfigurationTipProps {
	className?: string
	showInstallationHint?: boolean
}

export const LanguageConfigurationTip = ({
	className = '',
	showInstallationHint = true,
}: LanguageConfigurationTipProps) => {
	const { t } = useTranslation()
	
	return (
		<div
			className={`p-4 bg-blue-50 dark:bg-blue-950/30 rounded-xl border border-blue-200 dark:border-blue-800/50 ${className}`}>
			<div className="flex items-start gap-3">
				<div className="p-2 bg-blue-100 dark:bg-blue-900/50 rounded-lg flex-shrink-0">
					<Languages className="h-4 w-4 text-blue-600 dark:text-blue-400" />
				</div>
				<div className="flex-1 min-w-0">
					<h4 className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">
						{t('languageTip.title')}
					</h4>
					<p className="text-sm text-blue-700 dark:text-blue-300 mb-3">
						{showInstallationHint
							? t('languageTip.configureDuringInstallation')
							: t('languageTip.configureWhenInstalling')}
							<Link to="https://feedbask.com/docs#language-configuration"
							className='text-md inline-flex items-center gap-1 text-blue-600 dark:text-blue-400 hover:underline hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200 font-medium'> {t('languageTip.seeDocumentation')}</Link>
					</p>
					<div className="flex flex-wrap gap-2 mb-3">
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇺🇸 {t('languageTip.english')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇫🇷 {t('languageTip.french')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇩🇪 {t('languageTip.german')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇪🇸 {t('languageTip.spanish')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇨🇳 {t('languageTip.chinese')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇰🇭 {t('languageTip.khmer')}
						</span>
						<span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white dark:bg-blue-900/30 rounded-md text-xs font-medium text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700/50">
							🇻🇳 {t('languageTip.vietnamese')}
						</span>
					</div>
					<p className="text-xs text-blue-600 dark:text-blue-400">
						{t('languageTip.needMoreLanguages')}{' '}
						<button
							onClick={() => {
								if (window.feedbask && window.feedbask.openFeature) {
									window.feedbask.openFeature()
								}
							}}
							className="text-md inline-flex items-center gap-1 text-blue-600 dark:text-blue-400 hover:underline hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200 font-medium">
							{t('languageTip.submitLanguageRequest')}
						</button>
					</p>
				</div>
			</div>
		</div>
	)
}
